import { styled } from '@mui/material';
import React, { useState, cloneElement, ReactElement, ReactNode, Children } from 'react';
import { ExpandableContainerProps } from './ExpandableContainer';

interface ExpandableListProps {
  children: ReactNode;
  name: string | null;
}

export const ExpandableList: React.FC<ExpandableListProps> = ({ children, name }) => {
  const childArray = Children.toArray(children) as ReactElement<ExpandableContainerProps>[];
  const [expandedIndex, setExpandedIndex] = useState<number | null>(null);

  const handleToggle = (index: number, value: boolean) => {
    setExpandedIndex(value ? index : null);
  };

  return (
    <StyledList
      role='list'
      aria-label={name ?? 'Expandable List'}
    >
      {childArray.map((child, index) =>
        cloneElement(child, {
          index,
          expanded: expandedIndex === index,
          onToggle: handleToggle,
          key: child.key ?? index,
        })
      )}
    </StyledList>
  );
};

const StyledList = styled('div')`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(3)};
`;
